<template>
<div class="content" id="AdvertIndex">
	<router-view />
</div>
</template>
<script>
export default {
    name: 'AdvertIndex',
    //组件创建
    created() {
    },
    data() {
        return{
        }
    },
    methods:{
    }
}
</script>
<style lang="less" scoped>
</style>